import React, { forwardRef, memo } from 'react'

const WhoSteps = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="408.8"
      height="95.9"
      viewBox="0 0 408.8 95.9"
      fill="none"
      {...props}>
      <circle cx="108.5455" cy="47.9167" r="2.9337" fill="#78BE20" />
      <circle cx="126.1477" cy="47.9169" r="2.9337" fill="#78BE20" />
      <circle cx="143.7499" cy="47.9169" r="2.9337" fill="#78BE20" />
      <circle cx="265.0088" cy="47.9167" r="2.9337" fill="#78BE20" />
      <circle cx="282.611" cy="47.9169" r="2.9337" fill="#78BE20" />
      <circle cx="300.2132" cy="47.9169" r="2.9337" fill="#78BE20" />

      <circle
        cx="47.9167"
        cy="47.9167"
        r="46.9388"
        fill="white"
        stroke="#EEEEEE"
        strokeWidth="1.956"
      />
      <g
        stroke="#78BE20"
        strokeWidth="1.956"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none">
        <path d="M56.7176 48.3424 46.9594 58.1005a2.24 2.24 0 0 1-2.8725 0L33.8215 47.8356a2.24 2.24 0 0 1 0-3.1564L45.5354 33.2489 59.6513 47.3648l-2.9337.9776Z" />
        <path d="M46.4497 47.917a2.4443 2.4443 0 1 0 0-4.8894 2.4443 2.4443 0 0 0 0 4.8894Z" />
        <path d="M44.7216 43.7438 36.1809 35.2043" />
        <path d="M61.6072 56.718c0 .519-.206 1.0165-.5728 1.3833a1.956 1.956 0 0 1-2.7458 0c-.3668-.3668-.5729-.8643-.5729-1.3833 0-1.9558 1.9557-4.8894 1.9557-4.8894s1.9558 2.9336 1.9558 4.8894Z" />
      </g>

      <circle
        cx="204.379"
        cy="47.9167"
        r="46.9388"
        fill="white"
        stroke="#EEEEEE"
        strokeWidth="1.956"
      />
      <g
        stroke="#78BE20"
        strokeWidth="1.956"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none">
        <path d="M189.711 57.696h27.381" />
        <path d="M215.136 57.696V40.0938h-5.868v-3.9115h-11.734v7.8231h-5.868V57.696" />
        <path d="M202.423 40.0938h1.956" />
        <path d="M202.423 44.0054h1.956" />
        <path d="M209.269 44.0054h1.956" />
        <path d="M195.578 47.917h1.956" />
        <path d="M195.578 51.8286h1.956" />
        <path d="M202.423 47.917h1.956" />
        <path d="M209.269 47.917h1.956" />
        <path d="M209.269 51.8286h1.956" />
        <path d="M201.446 57.696v-5.8674h3.911v5.8674" />
      </g>

      <circle
        cx="360.842"
        cy="47.9167"
        r="46.9388"
        fill="white"
        stroke="#EEEEEE"
        strokeWidth="1.956"
      />
      <g
        stroke="#78BE20"
        strokeWidth="1.956"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none">
        <path d="M359.864 50.8506a4.889 4.889 0 1 0 0-9.778 4.889 4.889 0 0 0 0 9.778Z" />
        <path d="M370.62 37.1602h-21.513c-.54 0-.978.438-.978.978v17.6022c0 .5403.438.9785.978.9785H370.62c.54 0 .978-.4382.978-.9785V38.1386c0-.5402-.438-.9784-.978-.9784Z" />
        <path d="M351.564 56.718c.606-1.7874 1.729-3.2047 3.215-4.2565 1.485-1.0518 3.264-1.711 5.085-1.711 1.821 0 3.599.6592 5.085 1.711 1.486 1.0518 2.609 2.4691 3.214 4.2565" />
      </g>
    </svg>
  )
)

WhoSteps.displayName = 'WhoSteps'

export default memo(WhoSteps)
